module.exports = __webpack_public_path__ + "static/media/inf_82og83.5c23fd5a.mp3";